export const money = (cents: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);

export const onlyDigits = (value: string) => value.replace(/\D/g, "");

export const maskCpf = (value: string) => {
  const digits = onlyDigits(value).slice(0, 11);
  return digits
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
};

export const maskCep = (value: string) =>
  onlyDigits(value).slice(0, 8).replace(/^(\d{5})(\d)/, "$1-$2");

export const maskPhone = (value: string) => {
  const digits = onlyDigits(value).slice(0, 11);
  return digits.length > 10
    ? digits.replace(/^(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3")
    : digits.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
};

export function isValidCpf(value: string) {
  const cpf = onlyDigits(value);
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  const digit = (factor: number) => {
    let total = 0;
    for (const char of cpf.slice(0, factor - 1)) total += Number(char) * factor--;
    const result = (total * 10) % 11;
    return result === 10 ? 0 : result;
  };
  return digit(10) === Number(cpf[9]) && digit(11) === Number(cpf[10]);
}

export type Product = {
  id: string;
  slug: string;
  name: string;
  subtitle: string;
  description: string;
  price_cents: number;
  compare_at_cents: number | null;
  personalization_enabled: number;
  personalization_price_cents: number;
  active: number;
  front_image: string;
  back_image: string;
  inventory: { size: string; stock: number }[];
};

export type User = {
  id: string;
  email: string;
  role: "customer" | "admin";
  full_name: string;
  cpf_masked: string;
  phone: string;
  birth_date?: string;
  postal_code: string;
  street: string;
  number: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
};

export type CartItem = {
  productId: string;
  name: string;
  image: string;
  size: string;
  nickname: string;
  quantity: number;
  unitPrice: number;
};

export type Storefront = {
  product: Product;
  products: Product[];
  settings: Record<string, string>;
};
